import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { HomeService } from "../home.service";

@Component({
  selector: 'app-edit-user-multiple-form',
  templateUrl: './edit-user-multiple-form.component.html',
  styleUrls: ['./edit-user-multiple-form.component.scss']
})
export class EditUserMultipleFormComponent implements OnInit {
  questionList = [];
  SectionList = [];
  forumData: any;
  tagName = "";
  totalQuestion: number = 0;
  totalFilled: number = 0;
  isSection: boolean = false;
  isLoading: boolean = false;
  isUploading:boolean=false;
  userId: any;
  formId:any;
  circleId:any;
  isFormEdited:any;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size: "lg",
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  formResponseId = ""
  interval:any;
  type:any
  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private modalService: NgbModal
  ) {}
  from = "";
  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      this.userId = param["userId"];
      this.formId = param["formId"];
      this.circleId = param["circleId"];
      this.from = param['from']
      this.formResponseId = param['formResponseId']
      this.type = param['type']
      if (param) {
          this.getUserFormEditedDetail();
      }
    });
   
  }

  getUserFormEditedDetail() {
    this.isLoading = true
    let query = "?formResponseId="+this.formResponseId;
    this.homeService.getUserFormEditedDetailApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.forumData = res.data.formResponseList[0];
          this.questionList = this.forumData['formData']['questions'];
          this.userReponse =  this.forumData['questions']
          if (this.questionList["0"]["sectionName"]) {
            this.isSection = true;
            this.SectionList = this.questionList;
            this.updateUserResponseSection();
            this.interval = setInterval(() => {
              this.validateSectionForum('')
            }, 1000);
          } else {
            this.isSection = false;
            this.updateUserResponse();
            this.interval = setInterval(() => {
              this.validateForum('')
            }, 1000);
           
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  ngOnDestroy() {
    localStorage.removeItem("question");
  }
  validateForum(event: any) {
    
    this.totalFilled = 0;
    this.totalQuestion = 0;
    for (let i = 0; i < this.questionList.length; i++) {
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "checkbox"
      ) {
        let count = 0;
        this.questionList[i]["values"].forEach((element) => {
       
          if (element["valueSelect"] == true) {
            if(count <= 0) {
              this.totalFilled = this.totalFilled + 1;
              count = count +1
            }
          }
        });
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "text"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "radio"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
       if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "number"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "date"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "singleSelect"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (this.questionList[i]["isRequired"] == true) {
        this.totalQuestion = this.totalQuestion + 1;
      }
    }
  }

// VALIDATE FOR SECTION REQUIRED FIEDS
validateSectionForum(event:any){
  this.totalFilled = 0;
  this.totalQuestion = 0;
  for(let j=0;j < this.SectionList.length;j++) {
    for (let i = 0; i < this.SectionList[j]['questions'].length; i++) {
      if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'checkbox'){
       let count= 0;
        this.SectionList[j]['questions'][i]['values'].forEach(element => {
        
          if (element["valueSelect"] == true) {
            if(count <= 0) {
              this.totalFilled = this.totalFilled + 1;
              count = count +1
            }
          }
          
        });
      }
      if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'text'){
        if(this.SectionList[j]['questions'][i]['valuesText'] !== ''){
          this.totalFilled = this.totalFilled +1
        }
      }
      if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'radio'){
        if(this.SectionList[j]['questions'][i]['valuesText'] !== ''){
          this.totalFilled = this.totalFilled +1
        }
      }
      if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'singleSelect'){
        if(this.SectionList[j]['questions'][i]['valuesText'] !== ''){
          this.totalFilled = this.totalFilled +1
        }
      }
      if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'number'){
        if(this.SectionList[j]['questions'][i]['valuesText'] !== ''){
          this.totalFilled = this.totalFilled +1
        }
      }
      if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'date'){
        if(this.SectionList[j]['questions'][i]['valuesText'] !== ''){
          this.totalFilled = this.totalFilled +1
        }
      }

      if(this.SectionList[j]['questions'][i]['isRequired'] == true ){
        this.totalQuestion = this.totalQuestion +1
      }
}
  }
}

openTagModal(content,btn) {
 
this.modelOptions = {
  backdrop: "static",
  keyboard: false,
  size: 'md'
};

btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
this.modalRef = this.modalService.open(content, this.modelOptions);
this.modalRef.result.then(
  result => {
    this.closeResult = `Closed with: ${result}`;
  },
  reason => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  }

);
}


  formEditSumbit () {
    if(this.isSection == true) {
      this.getResponseSection()
    } else {
      this.getResponse();
    }
        if (this.totalQuestion !== this.totalFilled) {
          return this._snackBar.open("Please fill all mandatory fields", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        } else {
          let req = {};
          if(this.isSection == false) {
            req['response'] = this.questionList;
            req['questions'] = this.finalResponse;
          } else {
            req['response'] = this.SectionList;
            req['questions'] = this.finalResponse;
          } 
          req['formResponseId'] = this.forumData.formResponseId;
          req['tagName']=this.tagName;
          this.isLoading = true
            this.homeService.submitSingleTypeForm(req).subscribe(
              (res) => {
                this.isLoading = false;
                if ((res["message"] = "Success")) {
                  this.modalRef.close()
                  this.router.navigate(["/main/multiple-form-list"],{ queryParams: { userId:this.userId,circleId:this.circleId,formId:this.formId}, preserveQueryParams: false });
                  return this._snackBar.open("Form submitted successfully !", "", {
                    duration: 3000,
                    horizontalPosition: "right",
                    verticalPosition: "top",
                    panelClass: ["success"],
                  });
                 
                } else {
                  this.isLoading = false;
                  this.modalRef.close()
                }
              },
              (err) => {
                this.isLoading = false;
                this.modalRef.close()
              }
            );
        }
  }

  navigateBAck(){
    if(this.type == "view") {
      this.router.navigate(["/main/user-response-form-view"],{ queryParams: { userId:this.userId,circleId:this.circleId,formId:this.formId,formResponseId:this.formResponseId,from:this.from}, preserveQueryParams: false });
    } else if(this.from == "admin_external") {
      this.router.navigate(["/main/setting/manage-forum/externalUser"],{ queryParams: { formId:this.formId,from:'Admin'}, preserveQueryParams: false });
    } else if(this.from == "circle_external") {
      this.router.navigate(["/main/circles/circle-profile/circle-members"],{ queryParams: { ownerId:this.userId,id:this.circleId}, preserveQueryParams: false });
    }  else {
      this.router.navigate(["/main/multiple-form-list"],{ queryParams: { userId:this.userId,circleId:this.circleId,formId:this.formId}, preserveQueryParams: false });
            
    }
   
  }
  isEdit:boolean = false;
  navigateEdit(){
    this.isEdit= !this.isEdit;
  }
  
  url = "";
  selectedFile: File;
  uploadAttachment(event,index) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    this.homeService.uploadImage(this.selectedFile).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res['data'].url;
          this.questionList[index]['valuesText'] = res.data.url;
          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);

        } else {
        }
      },
      err => {
        this.isLoading = false;
      }
    );
  }
  uploadAttachment1(event,Sectionindex,QuestionIndex) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    this.homeService.uploadImage(this.selectedFile).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res['data'].url;
          this.SectionList[Sectionindex]['questions'][QuestionIndex]['valuesText'] = res.data.url;
          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);

        } else {
        }
      },
      err => {
        this.isLoading = false;
      }
    );
  }
  openwebView(value) {
    let index =value.indexOf('http');
    let url  = '';
    if (index == -1) {
         url = 'http://' + value ;
    }
    else 
    {
        url = value ;
    }
    window.open(url, "_blank");
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  finalResponse =[]
  getResponse() {
    this.finalResponse = [];
    for (let i = 0; i < this.questionList.length; i++) {
        if ( this.questionList[i]['type'] == 'upload' || this.questionList[i]['type'] == 'date' ||this.questionList[i]['type'] == 'number' || this.questionList[i]['type'] == 'text' || this.questionList[i]['type'] == 'text' ) {
            this.finalResponse.push({
                questionId: this.questionList[i]['questionId'],
                answer: this.questionList[i]['valuesText'],
                headerName: this.questionList[i]['questionHeader']
            })
        }

        if(this.questionList[i]['type'] == 'checkbox') {
          let tempVal = [];
          this.questionList[i]['values'].forEach(element1 => {
            if (element1['valueSelect'] == true) {
              tempVal.push(element1['label'])
          }
          });
          this.questionList[i]['valuesText'] = tempVal.toString();
          this.finalResponse.push({
            questionId: this.questionList[i]['questionId'],
            answer: this.questionList[i]['valuesText'],
            headerName: this.questionList[i]['questionHeader']
          })
        }

      if (this.questionList[i]['type'] == 'radio') {
        this.finalResponse.push({
          questionId: this.questionList[i]['questionId'],
          answer: this.questionList[i]['valuesText'],
          headerName: this.questionList[i]['questionHeader']
        })
          this.questionList[i]['values'].forEach(element => {
            if (element['isLevel'] == true) {
            for (let j = 0; j < element['questions'].length; j++) {
              this.finalResponse.push({
                questionId: element['questions'][j]['questionId'],
                answer: element['questions'][j]['valuesText'],
                headerName: element['questions'][j]['questionHeader']
              })
            }
          }
          });
      }
      if (this.questionList[i]['type'] == 'singleSelect') {
        this.finalResponse.push({
          questionId: this.questionList[i]['questionId'],
          answer: this.questionList[i]['valuesText'],
          headerName: this.questionList[i]['questionHeader']
        })
          this.questionList[i]['values'].forEach(element => {
            if (element['isLevel'] == true) {
            for (let j = 0; j < element['questions'].length; j++) {
              this.finalResponse.push({
                questionId: element['questions'][j]['questionId'],
                answer: element['questions'][j]['valuesText'],
                headerName: element['questions'][j]['questionHeader']
              })
            }
          }
          });
      }
        
    }
}

getResponseSection() {
  this.finalResponse = [];
  for(let k = 0;k < this.SectionList.length;k++) {
    for (let i = 0; i < this.SectionList[k]['questions'].length; i++) {

      if ( this.SectionList[k]['questions'][i]['type'] == 'upload' || this.SectionList[k]['questions'][i]['type'] == 'date' || this.SectionList[k]['questions'][i]['type'] == 'number' || this.SectionList[k]['questions'][i]['type'] == 'text' || this.SectionList[k]['questions'][i]['type'] == 'text' ) {
          this.finalResponse.push({
              questionId: this.SectionList[k]['questions'][i]['questionId'],
              answer: this.SectionList[k]['questions'][i]['valuesText'],
              headerName: this.SectionList[k]['questions'][i]['questionHeader']
          })
      }

      if(this.SectionList[k]['questions'][i]['type'] == 'checkbox') {
    let tempVal = [];
    this.SectionList[k]['questions'][i]['values'].forEach(element1 => {
      if (element1['valueSelect'] == true) {
        tempVal.push(element1['label'])
    }
    });
  this.SectionList[k]['questions'][i]['valuesText'] = tempVal.toString();
  this.finalResponse.push({
    questionId: this.SectionList[k]['questions'][i]['questionId'],
    answer: this.SectionList[k]['questions'][i]['valuesText'],
    headerName: this.SectionList[k]['questions'][i]['questionHeader']
})
  }
  
    if (this.SectionList[k]['questions'][i]['type'] == 'radio') {
      this.finalResponse.push({
        questionId: this.SectionList[k]['questions'][i]['questionId'],
        answer: this.SectionList[k]['questions'][i]['valuesText'],
        headerName: this.SectionList[k]['questions'][i]['questionHeader']
      })
      this.SectionList[k]['questions'][i]['values'].forEach(element => {
          if (element['isLevel'] == true) {
          for (let j = 0; j < element['questions'].length; j++) {
            this.finalResponse.push({
              questionId: element['questions'][j]['questionId'],
              answer: element['questions'][j]['valuesText'],
              headerName: element['questions'][j]['questionHeader']
            })
          }
        }
        });
    }
    if (this.SectionList[k]['questions'][i]['type'] == 'singleSelect') {
      this.finalResponse.push({
        questionId: this.SectionList[k]['questions'][i]['questionId'],
        answer:this.SectionList[k]['questions'][i]['valuesText'],
        headerName: this.SectionList[k]['questions'][i]['questionHeader']
      })
      this.SectionList[k]['questions'][i]['values'].forEach(element => {
          if (element['isLevel'] == true) {
          for (let j = 0; j < element['questions'].length; j++) {
            this.finalResponse.push({
              questionId: element['questions'][j]['questionId'],
              answer: element['questions'][j]['valuesText'],
              headerName: element['questions'][j]['questionHeader']
            })
          }
        }
        });
    }
      
  }
  }
}

userReponse = [];
updateUserResponseSection() {
  for (let k = 0; k < this.SectionList.length; k++) {
    for (let i = 0; i < this.SectionList[k]['questions'].length; i++) {

      if (this.SectionList[k]['questions'][i]['type'] == 'upload' || this.SectionList[k]['questions'][i]['type'] == 'date' || this.SectionList[k]['questions'][i]['type'] == 'number' || this.SectionList[k]['questions'][i]['type'] == 'text') {
        this.userReponse.forEach(element => {
          if (this.SectionList[k]['questions'][i]['questionId'] == element['questionId']) {
            this.SectionList[k]['questions'][i]['valuesText'] = element['answer']

          }
        });
      }

      if(this.SectionList[k]['questions'][i]['type'] == 'checkbox' ) {
        let valueText = [];
        this.userReponse.forEach(element => {
          if (this.SectionList[k]['questions'][i]['questionId'] == element['questionId']) {
            valueText = element['answer'].split(',')
            valueText.forEach(element => {
              for(let j = 0;j < this.SectionList[k]['questions'][i]['values'].length ;j++) {
                if(this.SectionList[k]['questions'][i]['values'][j]['label'] == element) {
                  this.SectionList[k]['questions'][i]['values'][j]['valueSelect'] = true
                }
              }
            });
          }
        });

      
      }
      
      

      if (this.SectionList[k]['questions'][i]['type'] == 'radio') {

        for (let p = 0; p < this.userReponse.length; p++) {
          if (this.SectionList[k]['questions'][i]['questionId'] == this.userReponse[p]['questionId']) {
            this.SectionList[k]['questions'][i]['valuesText'] = this.userReponse[p]['answer']
          }
        }

        this.SectionList[k]['questions'][i]['values'].forEach(element => {
          if (element['isLevel'] == true) {
            for (let j = 0; j < element['questions'].length; j++) {
              for (let m = 0; m < this.userReponse.length; m++) {
                if (element['questions'][j]['questionId'] == this.userReponse[m]['questionId']) {
                  element['questions'][j]['valuesText'] = this.userReponse[m]['answer']
                }
              }

            }
          }
        });
      }
      
      if (this.SectionList[k]['questions'][i]['type'] == 'singleSelect') {

        for (let p = 0; p < this.userReponse.length; p++) {
          if (this.SectionList[k]['questions'][i]['questionId'] == this.userReponse[p]['questionId']) {
            this.SectionList[k]['questions'][i]['valuesText'] = this.userReponse[p]['answer']
          }
        }

        this.SectionList[k]['questions'][i]['values'].forEach(element => {
          if (element['isLevel'] == true) {
            for (let j = 0; j < element['questions'].length; j++) {
              for (let m = 0; m < this.userReponse.length; m++) {
                if (element['questions'][j]['questionId'] == this.userReponse[m]['questionId']) {
                  element['questions'][j]['valuesText'] = this.userReponse[m]['answer']
                }
              }

            }
          }
        });
      }


    }
  }


}
updateUserResponse() {
  for (let i = 0; i < this.questionList.length; i++) {
    if (this.questionList[i]['type'] == 'upload' || this.questionList[i]['type'] == 'date' || this.questionList[i]['type'] == 'number' || this.questionList[i]['type'] == 'text') {
      this.userReponse.forEach(element => {
        if (this.questionList[i]['questionId'] == element['questionId']) {
          this.questionList[i]['valuesText'] = element['answer']

        }
      });
    }

    if(this.questionList[i]['type'] == 'checkbox') {
      let valueText = [];
      this.userReponse.forEach(element => {
        if(this.questionList[i]['questionId'] == element['questionId']) {
          valueText = element['answer'].split(',')

          valueText.forEach(element => {
            for(let j = 0;j < this.questionList[i]['values'].length; j++) {
              if(this.questionList[i]['values'][j]['label'] == element) {
                this.questionList[i]['values'][j]['valueSelect'] = true
              }
            }
          });

        }
      })
    }

    if (this.questionList[i]['type'] == 'radio') {

      for (let p = 0; p < this.userReponse.length; p++) {
        if (this.questionList[i]['questionId'] == this.userReponse[p]['questionId']) {
          this.questionList[i]['valuesText'] = this.userReponse[p]['answer']
        }
      }


      this.questionList[i]['values'].forEach(element => {
        if (element['isLevel'] == true) {
          for (let j = 0; j < element['questions'].length; j++) {
            for (let m = 0; m < this.userReponse.length; m++) {
              if (element['questions'][j]['questionId'] == this.userReponse[m]['questionId']) {
                element['questions'][j]['valuesText'] = this.userReponse[m]['answer']
              }
            }
          }
        }
      });
    }

   
    if (this.questionList[i]['type'] == 'singleSelect') {

      for (let p = 0; p < this.userReponse.length; p++) {
        if (this.questionList[i]['questionId'] == this.userReponse[p]['questionId']) {
          this.questionList[i]['questions'][i]['valuesText'] = this.userReponse[p]['answer']
        }
      }


      this.questionList[i]['values'].forEach(element => {
        if (element['isLevel'] == true) {
          for (let j = 0; j < element['questions'].length; j++) {
            for (let m = 0; m < this.userReponse.length; m++) {
              if (element['questions'][j]['questionId'] == this.userReponse[m]['questionId']) {
                element['questions'][j]['valuesText'] = this.userReponse[m]['answer']
              }
            }
          }
        }
      });
    }

  }

}



// 
validateCheckBox (vv) {
}

}
